module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAMAAABYzB2OAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEUAAABOT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT09OT08AAABMAGakAAAAEHRSTlMAXu/rU/pOY2n3Qm72eHuIdBVsHQAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAABaSURBVAjXXc1LDsAgCATQEf9YlfuftqLRtLKZySMBGLIOZ5wlAxLxYUvwIqR0TGVQlGNTJAJJMzPAWVvSZdH2MD+aZZ2o06bU/WjaT4C2pOEzXaUDl10y7MgLjlsFh8ZPamgAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTQtMTEtMThUMTY6Mzg6NTUtMDg6MDDeAtGyAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE0LTExLTE4VDE2OjM4OjU1LTA4OjAwr19pDgAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/header/menu_arrow@2x.png
 ** module id = 833
 ** module chunks = 0 1
 **/